/**
 * @desc 根据sku推送供应商报价信息
 */
const URL = "/rantion-srm";
import http, { updateResponse } from "@/http";
export function request(body: Array<string>, options?: any) {
  return updateResponse(
    http(URL + `/srm/supplierQuotation/updateBasicsSkuMoq`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
